"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = exports.StyledWripperTitle = exports.StyledBreadcrumbsItem = exports.StyledBreadcrumbs = exports.StyledClassName = exports.StyledTitle = exports.StyledBreadcrumbsWrapper = void 0;
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledBreadcrumbsWrapper = (0, styled_components_1.default)(material_1.Paper) `
  && {
    margin: ${({ theme }) => theme.spacing(1.25, 0, 2, 3)};
    padding: ${({ theme }) => theme.spacing(2)};
    width: ${({ theme }) => theme.spacing(44.875)};
    background-color: ${({ theme }) => theme.palette.primary.light};

    &.MuiPaper-root {
      box-shadow: none;
      border: ${({ theme }) => theme.typography.pxToRem(1)} solid ${ui_components_1.baseColors.primaryGreen200}
    }
  }
`;
exports.StyledTitle = (0, styled_components_1.default)(ui_components_1.Typography) `
  color: ${ui_components_1.baseColors.black}
`;
exports.StyledClassName = (0, styled_components_1.default)(ui_components_1.Typography) `
  color: ${ui_components_1.baseColors.black}
`;
exports.StyledBreadcrumbs = (0, styled_components_1.default)(material_1.Breadcrumbs) `
  .MuiBreadcrumbs-li:last-child {
    span {
      font-weight: 700;
    }
  }
  
  .MuiBreadcrumbs-separator {
    margin: 0;

    .MuiSvgIcon-root {
      font-size: 1.125rem;
    }
  }
`;
exports.StyledBreadcrumbsItem = (0, styled_components_1.default)(ui_components_1.Typography) `
  font-weight: 300;
  font-style: italic;
  color: ${ui_components_1.baseColors.black}
`;
exports.StyledWripperTitle = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
`;
exports.StyledButton = styled_components_1.default.button `
  border: none;
  background: transparent;
  color: ${ui_components_1.baseColors.primaryGreen200};
  font-weight: bold;
  cursor: pointer;
  text-transform: uppercase;
`;
